import { DeliveryOptionType } from "@jti/store/slices/LEGACY__checkoutSlice";
import { type CheckoutShippingStepData } from "@jti/store/slices/standardCheckoutFormSlice";

import { SHIPPING_FORM_FIELDS } from "../../constants";
import type { SelectedShippingAddress } from "../../ShippingForm.types";
import { getExternalShippingCarrierMagentoAddress } from "../getExternalShippingCarrierMagentoAddress";
import { getInStoreDeliveryMagentoAddress } from "../getInStoreDeliveryMagentoAddress";

type GetSelectedShippingAddressData = Partial<
  Pick<
    CheckoutShippingStepData,
    | "deliveryOptionType"
    | typeof SHIPPING_FORM_FIELDS.atHomeDeliveryShippingAddress
    | "inStoreDeliveryStore"
    | "externalShippingCarrier"
  >
>;

export const getSelectedShippingAddress = ({
  deliveryOptionType,
  [SHIPPING_FORM_FIELDS.atHomeDeliveryShippingAddress]: atHomeDeliveryShippingAddress,
  inStoreDeliveryStore,
  externalShippingCarrier,
}: GetSelectedShippingAddressData): SelectedShippingAddress | undefined => {
  if (deliveryOptionType === DeliveryOptionType.AtHome) {
    return atHomeDeliveryShippingAddress;
  }

  if (deliveryOptionType === DeliveryOptionType.InStoreJti && !!inStoreDeliveryStore) {
    return getInStoreDeliveryMagentoAddress(inStoreDeliveryStore);
  }

  if (deliveryOptionType === DeliveryOptionType.CustomDeliveryOption && externalShippingCarrier?.address) {
    return getExternalShippingCarrierMagentoAddress(externalShippingCarrier.address);
  }

  return undefined;
};
